import {useCallback} from "react";
import {BASE_URL, getAuthHeader} from "../config";

const useAPIService = () => {
  const apiFetch = useCallback(async (endpoint, options = {}) => {
    // Per-request auth: the verified Cognito Bearer token (JWT-only). Omit the
    // header entirely when not signed in so the API rejects it.
    const Authorization = await getAuthHeader();
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(Authorization ? {Authorization} : {}),
        ...options.headers,
      },
    });
    if (!response.ok) {
      // Try to read a JSON body so we can surface server-provided messages
      // (e.g. the OTP rate-limit reply: `{result, message, retry_after_seconds}`)
      // instead of the generic "HTTP error! status: 429". Existing callers
      // just read `err.message`, so this is backward-compatible -- they now
      // get the better message automatically. `err.status` / `err.body` are
      // attached for callers that want to branch on the response.
      let body = null;
      try {
        body = await response.json();
      } catch (_) {
        /* body wasn't JSON; fall through to generic message */
      }
      const message =
        body?.message ||
        options.errorMsg ||
        `HTTP error! status: ${response.status}`;
      const err = new Error(message);
      err.status = response.status;
      err.body = body;
      throw err;
    }
    return response.json();
  }, []);

  return {apiFetch};
};
export default useAPIService;
